import React from 'react';
import PropTypes from 'prop-types';
import T from './T';

export default class LanguageSwitcher extends React.Component {
  static contextTypes = {
    lang: PropTypes.object
  };

  render() {
    const { lang: { current: currentLang, changeLang } } = this.context;

    window.React = React;
    return (
      null
      // <span
      //   className="u-link"
      //   onClick={() => {
      //     changeLang(currentLang === 'en-GB' ? 'sk-SK' : 'en-GB');
      //   }}
      // >
      //   <T msg="anotherLang" />
      // </span>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/LanguageSwitcher.js